import Swal from 'sweetalert2';

export interface MailActionResult {
    emailSent: boolean;
    fallbackUrl?: string | null;
}

const copyText = async (value: string) => {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

export const showMailActionResult = async (result: MailActionResult | undefined, successMessage: string) => {
    if (result?.emailSent) {
        await Swal.fire({ icon: 'success', title: successMessage, confirmButtonText: 'Đóng' });
        return;
    }

    const fallbackUrl = result?.fallbackUrl;
    if (!fallbackUrl) {
        await Swal.fire({ icon: 'warning', title: successMessage, text: 'Không nhận được đường dẫn dự phòng.' });
        return;
    }

    const popup = await Swal.fire({
        icon: 'warning',
        title: 'Gửi email không thành công',
        text: 'Tác vụ đã hoàn tất. Hãy copy đường dẫn dưới đây và gửi trực tiếp cho user.',
        input: 'text',
        inputValue: fallbackUrl,
        inputAttributes: { readonly: 'true', 'aria-label': 'Đường dẫn gửi cho user' },
        showCancelButton: true,
        confirmButtonText: 'Copy link',
        cancelButtonText: 'Đóng',
        reverseButtons: true,
    });

    if (popup.isConfirmed) {
        try {
            await copyText(fallbackUrl);
            await Swal.fire({ icon: 'success', title: 'Đã copy link', timer: 1400, showConfirmButton: false });
        } catch {
            await Swal.fire({ icon: 'error', title: 'Không thể tự động copy', text: 'Vui lòng chọn và copy link thủ công.' });
        }
    }
};
